var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandReaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.465,
    height: 47.457,
    viewBox: "0 0 47.465 47.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15749",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15749",
    transform: "translate(-415.863 -287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21785",
    "data-name": "\\u30D1\\u30B9 21785",
    d: "M505.07,287c2.323.683,4.516,1.525,6.031,3.62a10.282,10.282,0,0,1,1.812,4.631c.14.939.187,2.037-1.141,2.185-1.313.146-1.484-.861-1.591-1.859a6.088,6.088,0,0,0-4.525-5.6,8.171,8.171,0,0,0-1.241-.178c-2.008-.221-2.409-1.119-1.242-2.8Z",
    transform: "translate(-49.652)",
    fill: "#54a2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21786",
    "data-name": "\\u30D1\\u30B9 21786",
    d: "M415.863,374.318c1.658-1.124,2.628-.792,2.715,1.161a6.1,6.1,0,0,0,5.85,5.913c.206.006.407.12.615.141.884.085,1.4.527,1.259,1.446-.135.9-.809,1.191-1.628,1.133a8.88,8.88,0,0,1-7.854-5c-.327-.644-.638-1.3-.957-1.943Z",
    transform: "translate(0 -49.662)",
    fill: "#53a2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21787",
    "data-name": "\\u30D1\\u30B9 21787",
    d: "M435.566,294.535a2.912,2.912,0,0,1,2.516-2.664c1.329-.221,2.116.688,2.8,1.683q5.832,8.538,11.671,17.072a3.237,3.237,0,0,0-1.615.929,13.225,13.225,0,0,0-2.447,16.428c.423.718.978,1.741,1.884,1.189.693-.422-.21-1.189-.484-1.731-2.48-4.889-2.136-9.486,1.254-13.842.606-.779,1.6-1.246,1.855-2.3,1.142.023,1.284-.606,1.082-1.557-.578-2.721-1.12-5.449-1.674-8.175-.424-2.083.158-3.223,1.891-3.72,1.464-.419,2.6.3,3.244,2.206,1.777,5.223,3.653,10.4,5.757,15.51a15.48,15.48,0,0,1-5.921,18.639,15.819,15.819,0,0,1-19.421-1.361c-.27-.239-.573-.44-.861-.659l.006.006q-6.508-9.4-13.021-18.8c-.757-1.088-1.35-2.2-.653-3.5.688-1.282,1.924-1.512,3.252-1.454l-.019-.016c.061.26.282.291.489.343,1.195,1.655,2.407,3.3,3.579,4.968,1.2,1.715,2.369,3.459,3.552,5.189.175.255.357.622.715.427a.824.824,0,0,0,.427-.936,2.94,2.94,0,0,0-.439-.831c-2.374-3.459-4.8-6.88-7.11-10.382-.926-1.4-2.378-2.6-2.212-4.557.563-1.957,1.53-2.459,3.955-2.053l8.916,12.94c.341.495.61,1.318,1.4.707.683-.528.015-1.051-.276-1.479-2.123-3.121-4.316-6.2-6.4-9.34a39.341,39.341,0,0,1-3.982-6.378c.656-2.368,2.736-2.933,3.924-2.338.877.439,1.31,1.337,1.971,2,.764,1.191,1.5,2.4,2.3,3.57,2.221,3.253,4.469,6.488,6.7,9.732.314.456.672.948,1.252.491.523-.412.055-.89-.18-1.248-.95-1.45-1.982-2.847-2.918-4.3C440.087,301.463,437.357,298.3,435.566,294.535Z",
    transform: "translate(-4.156 -2.772)",
    fill: "#fcd155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21788",
    "data-name": "\\u30D1\\u30B9 21788",
    d: "M436.365,370.179c.031,2.278-.495,2.742-2.8,2.469-6.608-.781-10.9-5.055-11.682-11.651-.037-.312-.022-.63-.035-.945-.041-.991.175-1.855,1.364-1.894,1.146-.038,1.384.875,1.378,1.737-.03,4.011,4.123,8.729,8.233,9.752,1.156.287,2.363.364,3.547.537Z",
    transform: "translate(-3.427 -40.771)",
    fill: "#54a2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21789",
    "data-name": "\\u30D1\\u30B9 21789",
    d: "M489.008,293.019a12.739,12.739,0,0,1,12.26,11.246,10.856,10.856,0,0,1,.207,1.87,1.3,1.3,0,0,1-1.228,1.4c-.851.067-1.256-.468-1.413-1.194-.122-.561-.086-1.154-.193-1.719a11,11,0,0,0-9.36-8.783c-.156-.02-.316-.007-.473-.024-.944-.1-1.868-.316-1.775-1.53C487.125,293.081,488.04,292.958,489.008,293.019Z",
    transform: "translate(-40.774 -3.441)",
    fill: "#53a2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21790",
    "data-name": "\\u30D1\\u30B9 21790",
    d: "M484.589,336.507c-.258,1.055-1.249,1.523-1.855,2.3-3.389,4.355-3.734,8.953-1.254,13.842.275.541,1.177,1.308.484,1.731-.906.552-1.461-.471-1.884-1.189a13.225,13.225,0,0,1,2.447-16.428,3.237,3.237,0,0,1,1.615-.929Z",
    transform: "translate(-35.749 -27.98)",
    fill: "#e78d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21791",
    "data-name": "\\u30D1\\u30B9 21791",
    d: "M436.911,304.026a39.341,39.341,0,0,0,3.982,6.378c2.087,3.144,4.28,6.219,6.4,9.34.292.428.959.951.276,1.479-.79.611-1.059-.212-1.4-.707l-8.916-12.94A2.917,2.917,0,0,1,436.911,304.026Z",
    transform: "translate(-11.795 -9.755)",
    fill: "#e78d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21792",
    "data-name": "\\u30D1\\u30B9 21792",
    d: "M428.224,317.148c-.166,1.953,1.286,3.153,2.212,4.557,2.308,3.5,4.736,6.923,7.11,10.382a2.941,2.941,0,0,1,.439.831.824.824,0,0,1-.427.936c-.357.2-.54-.171-.715-.427-1.182-1.731-2.347-3.474-3.552-5.189-1.172-1.671-2.385-3.313-3.58-4.968-.123-.171-.208-.4-.489-.343l.019.016c.088-.83-.585-1.287-.959-1.874A3.236,3.236,0,0,1,428.224,317.148Z",
    transform: "translate(-6.719 -17.274)",
    fill: "#e68c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21793",
    "data-name": "\\u30D1\\u30B9 21793",
    d: "M451.734,298.154c1.791,3.769,4.522,6.928,6.755,10.41.936,1.458,1.968,2.855,2.918,4.305.234.358.7.836.18,1.248-.58.457-.938-.035-1.252-.491-2.233-3.244-4.481-6.479-6.7-9.732-.8-1.168-1.534-2.379-2.3-3.57C451.407,299.59,451.192,298.8,451.734,298.154Z",
    transform: "translate(-20.324 -6.391)",
    fill: "#e78d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21794",
    "data-name": "\\u30D1\\u30B9 21794",
    d: "M431.413,330.67c.28-.053.365.172.489.343C431.7,330.962,431.474,330.93,431.413,330.67Z",
    transform: "translate(-8.909 -25.017)",
    fill: "#fefffe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandReaction);
export default __webpack_public_path__ + "static/media/handReaction.8f5e0c9ed1cbf7174538c23fda2c371a.svg";
export { ForwardRef as ReactComponent };